import { render, staticRenderFns } from "./Kinshasa.vue?vue&type=template&id=3f9cd67e&"
import script from "./Kinshasa.vue?vue&type=script&lang=js&"
export * from "./Kinshasa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports